import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@tempmee/react';

/**
 * The frame a DS tab body sits in on the office and professional profiles.
 *
 * width="100%": the profile's tab wrapper is a centring flex column, so
 * without it the body shrinks to its table's intrinsic width. `pt` keeps every
 * tab's card the same distance from the tab bar.
 */
export const ProfileTabBody = ({ children }) => (
  <Box pt={4} width="100%">
    {children}
  </Box>
);

ProfileTabBody.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ProfileTabBody;
